var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBase = function SvgBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.167C2 3.91 2 3.28 2.39 2.89 2.782 2.5 3.41 2.5 4.668 2.5h6.666c1.257 0 1.886 0 2.277.39.39.391.39 1.02.39 2.277v6.666c0 1.257 0 1.886-.39 2.277-.391.39-1.02.39-2.277.39H4.667c-1.257 0-1.886 0-2.276-.39C2 13.719 2 13.09 2 11.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.167h2c.654 0 .981 0 1.263.14s.478.403.87.926l.4.534c.393.523.59.785.87.925.282.141.61.141 1.264.141H12c.621 0 .932 0 1.177-.101.327-.136.586-.395.722-.722C14 6.765 14 6.454 14 5.833M4.667 11.167H10"
  })));
};
export default SvgBase;